export const enum PhoneValidatorOptions {
	MOBILE,
	LANDLINE,
	BOTH
}
